import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/landing.css';
import scene1 from '../images/Winter.png';
import scene2 from '../images/EarlySpring.png';
import scene3 from '../images/Spring.png';
import scene4 from '../images/Summer.png';
import scene5 from '../images/Fall.png';
import FHText from '../images/FHText.svg';

const Landing = () => {
  const [currentScene, setCurrentScene] = useState(0);
  const scenes = [scene1, scene2, scene3, scene4, scene5];

  useEffect(() => {
    const transitionScenes = setInterval(() => {
      setCurrentScene((prev) => {
        if (prev === scenes.length - 1) {
          clearInterval(transitionScenes); // Stop at the last scene
          return prev;
        }
        return prev + 1;
      });
    }, 1250);

    return () => clearInterval(transitionScenes);
  }, []);

  return (
    <div className="landing-background">
      <div className="landing-content">
        <div className="svg-and-text-wrapper fade-in">
          <div className="svg-and-text-container p-md-3">
            {/* Scene Animation */}
            <div className="svg-container">
              {scenes.map((scene, index) => (
                <img
                  key={index}
                  src={scene}
                  alt={`Scene ${index + 1}`}
                  className={`svg-scene ${currentScene === index ? 'active' : ''}`}
                />
              ))}
            </div>

            {/* Text Logo */}
            <div className="fh-text-container mb-4">
              <img src={FHText} alt="FHText Logo" className="fh-text-svg" />
            </div>

            {/* Route-Based Navigation Buttons */}
            <div className="navigation-row">
              <Link to="/services" className="nav-button">Services</Link>
              <Link to="/about" className="nav-button">About</Link>
              <Link to="/contact" className="nav-button">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
